import { render, staticRenderFns } from "./dataDistribute.vue?vue&type=template&id=173e3b34&scoped=true"
import script from "./dataDistribute.vue?vue&type=script&lang=js"
export * from "./dataDistribute.vue?vue&type=script&lang=js"
import style0 from "./dataDistribute.vue?vue&type=style&index=0&id=173e3b34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173e3b34",
  null
  
)

export default component.exports